import { AppNode } from "@features/builder/graph/types"
import { useReactFlow, useStoreApi } from "@xyflow/react"
import { useEffect } from "react"

/**
 * If node under cursor is not selected then unselect all other nodes, and select it,
 * however when node under the cursor is already selected, this hook will not be executed.
 */
export function useSelectCurentNode(id: string) {
  const { getNode, getNodes } = useReactFlow<AppNode>()
  const store = useStoreApi<AppNode>()

  useEffect(() => {
    const isMouseOverSelected: boolean = !!getNode(id)?.selected
    if (isMouseOverSelected) return

    const nothingSelected: boolean = !getNodes().find((node) => node.selected)?.selected
    if (nothingSelected) {
      store.getState().addSelectedNodes([id])
    }

    const areNodesSelected: boolean = !nothingSelected
    const isMouseOutsideSelection: boolean = !isMouseOverSelected

    if (areNodesSelected && isMouseOutsideSelection) {
      store.getState().resetSelectedElements()
      store.getState().addSelectedNodes([id])
    }
  }, [getNode, getNodes, id, store])
}
